import React from 'react';

export const DocusignSearchResultIcon = () => (
	<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			d="M26.6891 26.6013V34.2717C26.6891 34.6746 26.3626 35 25.9584 35H5.73074C5.3265 35 5 34.6746 5 34.2717V14.1271C5 13.7242 5.3265 13.3988 5.73074 13.3988H13.4113V25.873C13.4113 26.2759 13.7378 26.6013 14.1421 26.6013H26.6891Z"
			fill="#4C00FF"
		/>
		<path
			d="M35.116 15.7851C35.116 22.2314 31.3379 26.5858 26.6891 26.6012V18.4814C26.6891 18.249 26.5958 18.0166 26.4248 17.8616L22.1958 13.6467C22.0248 13.4763 21.8071 13.3833 21.5739 13.3833H13.4269V5.72835C13.4269 5.32545 13.7534 5.00004 14.1576 5.00004H25.5541C30.9647 4.98455 35.116 9.32338 35.116 15.7851Z"
			fill="#FF5252"
		/>
		<path
			d="M26.4248 17.846C26.5958 18.0165 26.6891 18.2334 26.6891 18.4659V26.5857H14.1576C13.7534 26.5857 13.4269 26.2603 13.4269 25.8574V13.3832H21.5739C21.8071 13.3832 22.0403 13.4762 22.1958 13.6467L26.4248 17.846Z"
			fill="black"
		/>
	</svg>
);
